import React, { Component } from 'react';

class BannerItem extends Component {
  render () {
    const { bannerColorCode, bannerUrl, bannerDsc, bannerLnk, pcWYn } = this.props.banner;
    const currentBgStyle = { backgroundColor: `#${bannerColorCode}` };
    const target = pcWYn === 'Y' ? '_blank' : '_self';

    return (
      <div className='re_banner_inner'>
        <a href={bannerLnk} style={currentBgStyle} className='reb_link' target={target}>{/* 배경컬러 운영자단에서 넣을수있도록 개발 */}
          <img className='reb_imgae' src={bannerUrl} alt={bannerDsc} />
        </a>
      </div>
    );
  }
}

export default BannerItem;
